import Keycloak from 'keycloak-js'
import {KEYCLOAK_CLIENTID, KEYCLOAK_REALM, KEYCLOAK_URL} from '@constants'

const keycloak = new Keycloak({
    url: KEYCLOAK_URL,
    realm: KEYCLOAK_REALM,
    clientId: KEYCLOAK_CLIENTID,
    pkceMethod: 'S256',
})

export default keycloak
